import { render, staticRenderFns } from "./LottieViewer.vue?vue&type=template&id=6142f1cc&scoped=true&"
import script from "./LottieViewer.vue?vue&type=script&lang=js&"
export * from "./LottieViewer.vue?vue&type=script&lang=js&"
import style0 from "./LottieViewer.vue?vue&type=style&index=0&id=6142f1cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6142f1cc",
  null
  
)

export default component.exports